import axios from 'axios';
import * as Sentry from '@sentry/react';
import getPath from '../assets/routes/paths';
import { getCurrentLanguage } from './helpers';
// import getPath from '../assets/routes/paths';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_V4_ENDPOINT,
  // baseURL: 'http://127.0.0.1:8000',
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' },
  crossDomain: true
  // withCredentials: true
});

instance.interceptors.request.use((config) => {
  const language = getCurrentLanguage();

  config.headers = {
    ...config.headers,
    'X-Language': language,
    'Accept-Language': `${language},en;q=0.8`
  };

  return config;
});

// instance.interceptors.request.use((config) => {
//   const language = window.localStorage.getItem('gh.language') || 'en';

//   config.headers = {
//     ...config.headers,
//     'X-Language': language,
//     'Accept-Language': `${language},en;q=0.8`
//   };

//   return config;
// });

instance.interceptors.response.use(
  (response) => {
    // console.log('Headers', response.headers);
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && !error.request?.responseURL.includes('/auth/token')) {
      const language = getCurrentLanguage();
      window.location = getPath(language, 'Login');
      // window.location = `${window.location.origin}/${language}/my-golf/login`;
    }
    return Promise.reject(error);
  }
);

const request = async (method, resource, body, token = null, fullErrorMessage = false) => {
  // console.log('request', method, resource, body, token);

  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await instance.request({
      method,
      // url: process.env.NODE_ENV ? `${resource}?isDev=1` : resource,
      url: resource,
      data: body
    });

    return Promise.resolve({ response: response.data });
  } catch (err) {
    console.log('ERR: ', err);
    if (err.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // console.log('Data', err.response.data);
      // console.log('Status:', err.response.status);
    } else if (err.request) {
      // console.log('Request: ', err.request);
      return Promise.resolve({ error: 'Network error!' });
    } else {
      Sentry.captureException(err);
      // console.log('Error Api', err.message);
      return Promise.resolve({ error: 'Unknown error' });
    }

    if (fullErrorMessage) {
      return Promise.resolve({ error: err.response?.data });
    }
    const error = err.response ? err.response.data.message : err.message;
    console.log('Error message:', error);
    return Promise.resolve({ error: error || 'Unknown error', errorCode: err.response?.data.code });
  }
};

export const get = (url, token = null, fullErrorMessage = false) => request('get', url, null, token, fullErrorMessage);
export const post = (url, body, token = null) => request('post', url, body, token);
export const put = (url, body, token = null) => request('put', url, body, token);
export const del = (url, body, token = null) => request('delete', url, body, token);

export const createKustomPayment = (cart) => post('/orders', cart);
export const validateKustomPayment = (order) => post(`/orders/validate`, order);
export const getDigitalCards = (orderId) => post(`/orders/${orderId}/digital-cards`);
